/* eslint-disable no-console */
import type { Field, FieldTypeMapping } from '@evidia/components';
import { SimpleForm } from '@evidia/components';
import { useActiveSchoolId } from '../../hooks/useActiveSchoolId';
import { trpc } from '../../utils/trcp';
import SignatureItem from '../StudentCard/Tabs/TrainingTab/SignatureItem';

const FIELDS = [
	{
		key: 'signature',
		label: '',
		required: true,
		type: 'custom',
		render: () => <SignatureItem title="" buttonText="Podepsat průkaz" />,
	},
] as const satisfies Field[];

interface Props {
	studentId: string;
	secretCode?: string;
	type: 'app' | 'student';
	schoolId?: string;
	registrationNumber?: string;
}

const SignatureForm: React.FC<Props> = ({ studentId, secretCode, schoolId, registrationNumber }) => {
	const getStudentPassSignature = trpc.studentPassSignature.getStudentPassSignature.useQuery({
		studentId,
		secretCode,
		schoolId: schoolId!,
		registrationNumber,
	});
	const createStudentPassSignature = trpc.studentPassSignature.createStudentPassSignature.useMutation();
	const { activeSchoolId } = useActiveSchoolId();

	return (
		<SimpleForm
			loading={getStudentPassSignature.isLoading}
			initialValues={{
				signature: getStudentPassSignature.data?.length === 0 ? undefined : getStudentPassSignature.data,
			}}
			fields={[
				{
					key: 'signature',
					label: '',
					required: true,
					type: 'custom',
					render: () => <SignatureItem title="" buttonText="Podepsat průkaz" />,
				},
			]}
			sendOnKeyValueChanged="signature"
			onFinish={async (values: FieldTypeMapping<typeof FIELDS>) => {
				await createStudentPassSignature.mutateAsync({
					studentId,
					signature: values.signature,
					secretCode,
					registrationNumber,
					schoolId: schoolId ?? activeSchoolId,
				});
			}}
			allowFinishFunctionLoading
		/>
	);
};

export default SignatureForm;
